import React from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';

const SKILL_KEY = 'Speaking';

const PART_STYLES = [
  { bg: 'linear-gradient(135deg, #ecfdf5, #d1fae5)', icon: '#10b981', border: '#6ee7b7', dot: '#10b981' },
  { bg: 'linear-gradient(135deg, #f0fdfa, #ccfbf1)', icon: '#14b8a6', border: '#99f6e4', dot: '#14b8a6' },
  { bg: 'linear-gradient(135deg, #eff6ff, #dbeafe)', icon: '#3b82f6', border: '#bfdbfe', dot: '#3b82f6' },
  { bg: 'linear-gradient(135deg, #f0f9ff, #e0f2fe)', icon: '#0ea5e9', border: '#bae6fd', dot: '#0ea5e9' },
  { bg: 'linear-gradient(135deg, #f5f3ff, #ede9fe)', icon: '#8b5cf6', border: '#c4b5fd', dot: '#8b5cf6' },
];

const SpeakingGrid = () => {
  const navigate = useNavigate();
  const apiUrl = `${process.env.REACT_APP_API_URL}/exercises/exercise-types?skill=speaking`;
  const { data: apiResponse, loading, error } = useFetch(apiUrl);

  if (loading) return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {[1, 2, 3].map(i => (
        <div key={i} style={{
          height: 88, borderRadius: 20,
          background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)',
          backgroundSize: '400px 100%',
          animation: 'shimmer 1.4s infinite',
        }} />
      ))}
    </div>
  );

  if (error) return (
    <div style={{ textAlign: 'center', padding: '40px 20px', color: '#ef4444' }}>
      <div style={{ fontSize: 40, marginBottom: 8 }}>😕</div>
      <p style={{ fontWeight: 600 }}>Không tải được danh sách bài tập.</p>
    </div>
  );

  const parts = apiResponse?.data || apiResponse || [];

  if (parts.length === 0) return (
    <div style={{ textAlign: 'center', padding: '48px 20px' }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>🎤</div>
      <p style={{ color: '#64748b', fontWeight: 600 }}>Chưa có bài tập Speaking nào.</p>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {parts.map((part, index) => {
        const style = PART_STYLES[index % PART_STYLES.length];
        return (
          <div
            key={part.id}
            onClick={() => navigate(`/skill-practice/part/${part.id}`)}
            style={{
              background: style.bg,
              border: `2px solid ${style.border}`,
              borderRadius: 20,
              padding: '18px 22px',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 18,
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
              position: 'relative', overflow: 'hidden',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
            }}
          >
            {/* Part number badge */}
            <div style={{
              width: 48, height: 48, borderRadius: 14, flexShrink: 0,
              background: 'white',
              border: `2px solid ${style.border}`,
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center',
              boxShadow: `0 4px 12px ${style.dot}22`,
            }}>
              <span style={{ fontSize: 10, fontWeight: 700, color: style.icon, lineHeight: 1 }}>Part</span>
              <span style={{ fontSize: 18, fontWeight: 900, color: style.icon, lineHeight: 1 }}>{index + 1}</span>
            </div>

            {/* Content */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 800, fontSize: 15, color: '#1e293b', marginBottom: 3 }}>
                {part.name}
              </div>
              {part.description && (
                <div style={{
                  fontSize: 13, color: '#64748b', lineHeight: 1.4,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '90%',
                }}>
                  {part.description}
                </div>
              )}
            </div>

            {/* Arrow */}
            <div style={{
              width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
              background: 'white', border: `2px solid ${style.border}`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: style.icon, fontWeight: 900, fontSize: 18,
            }}>
              →
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SpeakingGrid;